import { EmployeeProps } from "@/interfaces/employee_type"

export function DefaultProps({user}: {user: EmployeeProps}) {
    return {
        project_name: "",
        start_date: new Date().toISOString().split('T')[0],
        isDeadline: false,
        manager: {
            value: user.email,
            label: user.name,
        },
        template: {
            value: "Default",
            label: "Default",
        },
        status: {
            value: "Active",
            label: "Active",
        },
        category: {
            value: "FP",
            label: "New Construction",
        },
    }
}
